var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: "width:" + (_vm.width ? _vm.width : "100%;") },
    [
      _c("transition", { attrs: { duration: 100, name: "slide-fade" } }, [
        _c(
          "div",
          { staticStyle: { width: "100%", margin: "0 15px" } },
          [
            _vm._l(_vm.selectedList, function(e, i) {
              return [
                _c(
                  "div",
                  {
                    key: e.id,
                    staticClass: "item_0 item_0_selected",
                    attrs: { title: "点我可取消, 重新选择" },
                    on: {
                      click: function($event) {
                        return _vm.onClickCancel(e, i)
                      }
                    }
                  },
                  [
                    _c("van-icon", {
                      staticClass: "van-button__icon",
                      attrs: { name: "certificate" }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(e.name))])
                  ],
                  1
                )
              ]
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm.ticketTypeOption &&
      _vm.ticketTypeOption.length > 0 &&
      _vm.selectedList &&
      _vm.selectedList.length > 0
        ? _c("div", { staticStyle: { height: "10px" } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { duration: 100, name: "slide-fade" } },
        [
          _vm.ticketTypeOption && _vm.ticketTypeOption.length > 0
            ? _c(
                "van-radio-group",
                { staticStyle: { width: "100%", margin: "0 15px" } },
                [
                  _vm._l(_vm.ticketTypeOption, function(e) {
                    return [
                      _c(
                        "div",
                        {
                          key: e.id,
                          staticClass: "item_0",
                          class:
                            !!_vm.lastSelected && e.id == _vm.lastSelected.id
                              ? "item_0_selected"
                              : "",
                          on: {
                            click: function($event) {
                              return _vm.onClickSelect(e)
                            }
                          }
                        },
                        [
                          _c("van-icon", {
                            staticClass: "van-button__icon",
                            attrs: {
                              name:
                                !!_vm.lastSelected &&
                                e.id == _vm.lastSelected.id
                                  ? "certificate"
                                  : "circle"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(e.name))])
                        ],
                        1
                      )
                    ]
                  })
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d2ed4fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d2ed4fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile-ticket/MobileTicketTypePicker.vue
// module id = 648
// module chunks = 75